import React from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import {
  achievements,
  fullStackProfessional,
  SDET_Foundation,
  SDET_Advance,
} from "../assets/data";
import "../styles/certifications.css";
import swal from "sweetalert2";
import "animate.css";

const CertificationsSection = () => {
  const handleClick = (imageUrl) => {
    swal.fire({
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
      imageUrl: imageUrl,
      showConfirmButton: false,
      imageAlt: "Custom image",
    });
  };

  return (
    <div className="section3 animation">
      <h1 className="certification_title">Achievements</h1>
      <div className="certification_container">
        <div className="slider_container">
          {achievements.map((data) => {
            return (
              <div className="certification_image_container" key={data.key}>
                <img
                  src={data.achievement_image}
                  alt={data.key}
                  className="certification_image"
                  onClick={() => handleClick(data.achievement_image)}
                />
                <div className="caption_container">
                  <h4>{data.award_title}</h4>
                  <p>{data.achievement_description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <h2 className="certification_title">
        Full Stack Professional Certifications
      </h2>
      <div className="certification_container">
        <div className="slider_container">
          {fullStackProfessional.map((data) => {
            return (
              <div className="certification_image_container" key={data.key}>
                <img
                  src={data.achievement_image}
                  alt=""
                  className="certification_image"
                  onClick={() => handleClick(data.achievement_image)}
                />
                <div className="caption_container">
                  <h4>{data.achievement_description}</h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <h2 className="certification_title">SDET Foundation Certifications</h2>
      <div className="certification_container">
        <div className="slider_container">
          {SDET_Foundation.map((data) => {
            return (
              <div className="certification_image_container" key={data.key}>
                <img
                  src={data.achievement_image}
                  alt=""
                  className="certification_image"
                  onClick={() => handleClick(data.achievement_image)}
                />
                <div className="caption_container">
                  <h4>{data.achievement_description}</h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <h2 className="certification_title">SDET Advance Certifications</h2>
      <div className="certification_container">
        <div className="slider_container">
          {SDET_Advance.map((data) => {
            return (
              <div className="certification_image_container" key={data.key}>
                <img
                  src={data.achievement_image}
                  alt=""
                  className="certification_image"
                  onClick={() => handleClick(data.achievement_image)}
                />
                <div className="caption_container">
                  <h4>{data.achievement_description}</h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CertificationsSection;
